import KeyTakeaways from './KeyTakeaways'

export default KeyTakeaways
